enum FeatureFlagNames {
  EDITOR_SIDEBAR = 'proj-editor-sidebar',
  EDITOR_RIGHT_SIDEBAR = 'proj-editor-right-sidebar',
  SHOW_NEW_EDITOR_IN_LESSONS = 'proj-new-editor-in-lessons',
  WS_REVAMP = 'ws-revamp',
  LESSON_GEN_AI = 'proj-lesson-gen-ai',
  SUPER_WEEK = 'proj-super-week',
  SCHOOL_PICKER_COHORT = 'school-picker-cohort',
  LESSON_SIDEBAR_REVAMP = 'proj-lesson-sidebar-revamp',
  SHARED_LIBRARY_ACCESS = 'shared-library-access',
  REFERRALS = 'referrals',
  US_SUPER = 'us-super-refer-to-basic-user',
  DISABLE_EMPTY_QUIZ_DRAFT = 'disable-empty-quiz-draft',
  TEAM_CREATION_FLOW_V2 = 'team-creation-flow-v2',
  BTS_FC = 'bts-fc',
  BTS_WIDGET_FC = 'bts_widget_fc',
  IMPORT_FROM_OTHERS = 'import_content_anywhere',
  UXR_GROUP = 'uxr-group',
  UXR_GROUP2 = 'uxr-group-2',
  NEW_QUIZ_REVIEW_PAGE = 'new-quiz-review-page',
  RUN_TELEPORT_LESSON_VALIDATION = 'run-teleport-lesson-validation',
  SHOW_ADMIN_NPS = 'show-admin-nps',
  PROJ_IMG_CLIPPING = 'proj-img-clipping',
  GAME_MODE_SELECTION = 'game-mode-selection',
  PROJ_IMG_SUGGESTIONS = 'proj-img-suggestions',
  PROJ_CREATE_AI_FILE_CARD = 'proj-create-ai-file-card',
  PROJ_AI_RECOMMENDATIONS = 'proj-ai-recommendations',
  PROJ_AI_PREMIUM_RECOMMENDATIONS = 'proj-ai-premium-recommendations',
  MS_PARITY = 'ms_parity',
  MATHVERSE_TEACHER_DISCOVERY = 'mathverse-teacher-discovery',
  DIFFERENTIATION = 'proj-differentiation',
  DIFFERENTIATION_STUDENT_ORDER = 'proj-differentiation-so',
  DIFFERENTIATION_CLASS_ASSIGNMENT = 'proj-differentiation-class-assignment',
  DIFFERENTIATION_CLASS_ASSIGNMENT_OTHER = 'proj-differentiation-class-assignment-other',
  SKILLS_EXP = 'skills-exp',
  FC_ADMIN_V1 = 'fc_admin_v1',
  PAUSE_LESSON = 'pause-lesson',
  FC_ADMIN_REVAMP = 'fc_admin_revamp',
  PROJ_AI_STUDIO = 'proj-ai-studio',
  AI_CREATE_V2 = 'ai-create-v2',
  FREE_FOR_SCHOOLS_US = 'free-for-schools-us',
  NEW_GROWTH_ONBOARDING = 'new-growth-onboarding',
  VIDEO_AND_RC_ACTIVITY = 'video-and-rc-activity',
  GROWTH_IMPORT_SECTION = 'fc_import_section',
  BYOC_ONBOARDING = 'byoc_onboarding',
  DEMO_QUIZ_SCHOOLS = 'demo-quiz-for-schools',
  DISCOVERY_FEATURE_KILL_SWITCH = 'discovery_features_kill_switch',
  SEARCH_PREMIUM_ALTERNATIVE = 'ai-search-premium-recommendation',
  ACCOMMODATION_PAYWALLING_FC = 'accommodation-paywalling-fc',
  BILINGUAL_DICTIONARY = 'bilingual-dictionary',
  PREVIEW_QUIZ_EMPHASIS = 'preview-quiz-emphasis',
  HOMEPAGE_RECENTLY_VIEWED_CARDS = 'homepage-recently-viewed-quiz',
  SIGNUP_LAND_ON_QDP = 'signup-land-on-qdp',
  STATE_BASED_QUESTIONS_PREP = 'state-released-quiz-prep-explore',
  PREMIUM_HOSTING_BANNER = 'premium-hosting-banner',
  ACTIVATION_MATH_EXPLORE = 'activation-math-explore',
};

export default FeatureFlagNames;
